<template>
    <a v-if="show" v-bind:data-original-title="title" data-toggle="tooltip" v-bind:class="type" v-bind:href="link" target="_blank"><i class="fa" v-bind:class="icon"></i></a>
</template>
<script>
    import config from '../../config/app';
    import {isNull, filter} from 'lodash';

    export default {
        props : [ 'type' ],
        data : function()
        {
            return {
                social : null
            }
        },
        created : function()
        {
            let self = this;
            this.unsubscribe  = this.$store.subscribe((mutation,state) => {
                self.$language = self.$store.state.language;
                if( !isNull(self.$store.getters.config) )
                {
                    self.social = self.$store.getters.config.social;
                }
            });
            this.$store.watch( (state)=> {return this.$store.getters.config; }, (val) => {
                if( !isNull(val) )
                {
                    self.social = val.social;
                }
            });
        },
        computed : {
            show : function(){
                let self = this;
                let response = false;
                if( !isNull(this.social) )
                {
                    let keys = Object.keys( this.social );
                    return filter(keys, function(item){
                        return item == self.type;
                    }).length > 0;
                }
                return response;
            },
            link : function(){
                let response = null;
                if( !isNull(this.social) )
                {
                    try
                    {
                        return this.social[this.type];
                    }
                    catch(e)
                    {
                        console.error(e);
                    }
                }
                return response;
            },
            icon : function(){
                return config.social[this.type].icon;
            },
            title : function(){
                return config.social[this.type].title;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// SocialItem.vue?badc6372